module.exports = __webpack_public_path__ + "components/fullscreen-frame/icon-fullscreen-exit-fb3b2a6e89d20e3ce134d5348ab86e84.svg";